/***
 * @file:
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { COMMON_COMFIG } from '@ithinkdt/shared/utils';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

/**
 * **apiè¯·æ±æ¹å¼**ï¼ åªä¼å¨æ¥å£è¯·æ±æåçæ¶åå¨è¿éè¿åå¼ï¼å¤±è´¥ä¼å¨httpæ¦æªå¨è¿è¡æ¦æªï¼è¿éä¸åè¿åå¼å¤çã
 *
 * @example
 * åå¦ä¼ éè¿æ¥äºapiåparamï¼ä¸é¢æ¹æ³ä¼ç¨å°
 *  - api : `http://www.ithinkdt.com/user`,
 *  - param: `{userId: 1, pwd: 2}`
 *
 * @author linkun.he
 */

@Injectable({
  providedIn: 'root',
})
export class BaseAjaxService {
  headers_json = {
    headers: new HttpHeaders({
      'Content-Type': COMMON_COMFIG.POST_CONTENT_TYPE_JSON,
    }),
  };

  headers_form = {
    headers: new HttpHeaders({
      'Content-Type': COMMON_COMFIG.POST_CONTENT_TYPE_FORM,
    }),
  };

  constructor(@Inject(HttpClient) private http: HttpClient) {}

  /**
   * get è¯·æ±æ¹å¼
   * @param api API URL
   * @return æ¥å£è¿åå¼
   */
  protected get(api: string) {
    return this.sendGet(api);
  }

  /**
   * ä»¥formæ ¼å¼ï¼x-www-form-urlencodedï¼å°jsonå¯¹è±¡è½¬ä¸º`=`è¿æ¥çstringæ¾å¨bodyä¼ é
   * @param api API URL
   * @param param åæ°
   * @returns res è¯·æ±çç»æ
   * @example <p>åè¯·æ±çï¼ urlä¸åï¼bodyï¼"userId=1&pwd=2"  </p>
   */
  protected post(api: string, param?: any, opts = {}) {
    const body = this.transformObjToString(param);
    return this.sendPost(api, body, { ...this.headers_form, ...opts });
  }

  /**
   * ä»¥JSONæ ¼å¼ï¼ application/json, å°jsonå¯¹è±¡ç´æ¥è½¬ä¸ºstringæ¾å¨bodyä¸­ä¼ é
   * @param api API URL
   * @param param åæ°
   * @returns res è¯·æ±çç»æ
   * @example åè¯·æ±ç:  urlä¸å, bodyï¼{userId:1, pwd:2}
   */
  protected postJson(api?: string, param?: any, opts = {}) {
    const body = JSON.stringify(param);
    return this.sendPost(api, body, { ...this.headers_json, ...opts });
  }

  /**
   * ä»¥formæ ¼å¼ï¼x-www-form-urlencodedï¼å°jsonå¯¹è±¡è½¬ä¸º`=`è¿æ¥çstringæ¾å¨bodyä¼ é
   * @param api API URL
   * @param param åæ°
   * @returns res è¯·æ±çç»æ
   * @example <p>åè¯·æ±çï¼ urlä¸åï¼bodyï¼"userId=1&pwd=2"  </p>
   */
  protected put(api: string, param?: any, opts = {}) {
    const body = this.transformObjToString(param);
    return this.sendPut(api, body, { ...this.headers_form, ...opts });
  }

  /**
   * æ´æ°
   * ä»¥JSONæ ¼å¼ï¼ application/json, å°jsonå¯¹è±¡ç´æ¥è½¬ä¸ºstringæ¾å¨bodyä¸­ä¼ é
   * @param api API URL
   * @param param åæ°
   * @returns res è¯·æ±çç»æ
   * @example åè¯·æ±ç:  urlä¸å, bodyï¼{userId:1, pwd:2}
   */
  protected putJson(api?: string, param?: any, opts = {}) {
    const body = JSON.stringify(param);
    return this.sendPut(api, body, { ...this.headers_json, ...opts });
  }

  /**
   * å é¤: url queryStringæ¼æ¥æ¹å¼
   * @param api API URL
   * @param param åæ°
   * @returns res è¯·æ±çç»æ
   */
  protected delete(api?: string, param?: any) {
    const urlParam = this.transformObjToString(param);
    return this.sendDelete(api + '?' + urlParam);
  }

  /**
   * å é¤: body json stringæ¹å¼
   * @param api API URL
   * @param param åæ°
   * @returns res è¯·æ±çç»æ
   */
  protected deleteJson(api?: string, param?: any) {
    const body = JSON.stringify(param);
    return this.sendDelete(api, body);
  }

  /**
   * å¯¼å¥
   * @param api API URL
   * @param param åæ°
   * @returns res è¯·æ±çç»æ
   */
  protected postFile(url: string, param: any, opts = {}) {
    const formData = new FormData();
    formData.append('fileInputName', 'fileData');
    param.forEach((file: any) => {
      formData.append('fileData', file);
    });
    return this.sendPost(url, formData, opts);
  }

  /**
   * å¯¹è±¡è½¬æ¢ä¸º'='è¿æ¥çå­ç¬¦ä¸²
   * @param: éè¦è½¬æ¢çå¯¹è±¡
   * @return è½¬æ¢åçå­ç¬¦ä¸²
   */
  transformObjToString(obj) {
    if (!obj) {
      return;
    }
    const self = this;
    const body = Object.keys(obj)
      .reduce((a, k) => {
        if (obj[k] != null) {
          a.push(k + '=' + (obj[k] == null ? '' : encodeURIComponent(self.getParam(obj, k))));
        }
        return a;
      }, [])
      .join('&');

    return body;
  }

  /**
   * è¯»ååæ°ï¼å¹¶è½¬æ¢ææ åæ ¼å¼
   * @returns è½¬æ¢åçåæ°
   */
  getParam(param: any, key: string): any {
    const v = param[key];
    if (v != null) {
      if (v instanceof Date) {
        return v.getTime();
      }
    }
    return v;
  }

  /**
   * http get åºç¡æ¹æ³
   * @param api è®¿é®çapiå°å
   * @return æ¥å£è¯·æ±è¿åçå¼
   */
  sendGet(api): Observable<any> {
    return this.http.get(api).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => observableOf(error))
    );
  }

  /**
   * http poståºç¡æ¹æ³
   * @param api è®¿é®çapiå°å
   * @param body æºå¸¦çbodyåå®¹
   * @param options å¶ä»å¯ä¼ é¡¹
   * @return æ¥å£è¯·æ±è¿åçå¼
   */
  sendPost(api, body, options?): Observable<any> {
    return this.http.post(api, body, options).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => observableOf(error))
    );
  }

  /**
   * http putåºç¡æ¹æ³
   * @param api è®¿é®çapiå°å
   * @param body æºå¸¦çbodyåå®¹
   * @param options å¶ä»å¯ä¼ é¡¹
   * @return æ¥å£è¯·æ±è¿åçå¼
   */
  sendPut(api, body, options?): Observable<any> {
    return this.http.put(api, body, options).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => observableOf(error))
    );
  }

  /**
   * http delete åºç¡æ¹æ³
   * @param api è®¿é®çapiå°å
   * @param body æºå¸¦çbodyåå®¹
   * @return æ¥å£è¯·æ±è¿åçå¼
   */
  sendDelete(api, body?): Observable<any> {
    return this.http.delete(api, body).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => observableOf(error))
    );
  }
}
